
import axios from 'axios'

import BaseService from './BaseService'
const Environment = require('../environments/environment.json')

const getBusinessSalesReport = (reportStartDate, reportEndDate, sessionKey) =>
{
	const reportRequest =
	{
		reportStartDate: reportStartDate,
		reportEndDate: reportEndDate
	}
	
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.post(`${Environment.apiUrl}/Reports/BusinessSalesReport`, reportRequest, headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const downloadReportData = (reportDataItems, reportName) =>
{
	let csvString = ''
	
	const propertyNames = Object.keys(reportDataItems[0])
	for (let pn = 0; pn < propertyNames.length; pn++)
	{
		csvString = csvString + propertyNames[pn] + ','
	}
	csvString = csvString.substring(0, csvString.length - 1) + '\r\n'
	
	reportDataItems.forEach(reportDataItem =>
	{
		let propertyValues = Object.values(reportDataItem)
		for (let pv = 0; pv < propertyValues.length; pv++)
		{
			let val = propertyValues[pv] == null ? '' : String(propertyValues[pv])
			if (val.includes(',') || val.includes('"') || val.includes('\n'))
			{
				val = '"' + val.replace(/"/g, '""') + '"'
			}
			csvString = csvString + val + ','
		}
		csvString = csvString.substring(0, csvString.length - 1) + '\r\n'
	})
	
	// @ts-ignore
	if (window.Blob && window.navigator.msSaveOrOpenBlob)
	{
		let blobObject = new Blob(['\ufeff', csvString])
		// @ts-ignore
		window.navigator.msSaveOrOpenBlob(blobObject, `${reportName}.csv`)
	}
	else
	{
		let a: any = document.createElement('a')
		document.body.appendChild(a)
		a.style = 'display: none'
		
		let blob = new Blob(['\ufeff', csvString], {type: 'octet/stream'})
		let url = window.URL.createObjectURL(blob)
		
		a.href = url
		a.download = `${reportName}.csv`
		a.click()
		window.URL.revokeObjectURL(url)
	}
}

const getListingReport = (reportStartDate, reportEndDate, sessionKey) =>
{
	const reportRequest =
	{
		reportStartDate: reportStartDate,
		reportEndDate: reportEndDate
	}
	
	return new Promise((resolve, reject) =>
	{
		BaseService
			.requestHeaders(sessionKey)
			.then((headers) =>
			{
				resolve( axios.post(`${Environment.apiUrl}/Reports/ListingReport`, reportRequest, headers) )
			})
			.catch((error) =>
			{
				reject(error)
			})
	})
}

const ReportingService =
{
	getBusinessSalesReport,
	getListingReport,
	downloadReportData,
}

export default ReportingService
